<template>
    <div>
        <h1 class="mb-4 font-active">30-day returns</h1>
        <p>
            At Friendly Diamonds, we are confident that you will love our products. If a circumstance arises where you feel you need to return any item from your order, we are happy to help! We offer a 30-day, no questions asked return policy for a full refund.
        </p>

        <h3>Return Shipping</h3>
        <p>For customers within the United States, we offer FREE return shipping on all eligible items within 30 days of the delivery date. For customers outside the United States, we still offer a no questions asked 30-day return policy, though the customer is responsible for shipping costs.</p>

        <h3>Return Terms</h3>
        <p>All returned items must be in unworn condition, accompanied by all original packaging and documentation, including the diamond certificate. In case the item is used and worn out, $500 will be deducted from the total refund amount. A $150 replacement fee per certificate will be deducted from the refund amount if the certificate has been lost or tampered with. Appraisal fees of $50 are non-refundable. A deduction of $50 will be made from the refund amount for rings that have been engraved. The 30-day timeline begins from the date of order delivery. Due to the jewelry's personalized nature, bespoke custom designs and items that have been resized are not eligible for returns.Previously exchanged items are not eligible for returns or an additional exchange.</p>

        <h3>Return Packaging</h3>
        <p>Safe and secure packaging is a requirement for all eligible returns to ensure a safe transit. While shipping your products, it is mandatory to share the following images:</p><br>
        <ul>
            <li>Items inside the package (must show the merchandise being returned)</li>
            <li>Outside packaging (must be properly secured) </li>
        </ul>
        <p>Returns are subject to approval based on the quality and accuracy of the provided images. If the images are not shared or get disapproved by our team, your package will not be insured and might lead to insecure transit. In case of such instances, we will not be responsible for the safety of your parcel.</p>

        <h3>Cancellations</h3>
        <p>You reserve the right to cancel your order for a full refund before it has been shipped. Bespoke custom designs are not eligible for cancellations after the first 48 hours of order completion.</p>

        <h3>How To Return Your Order?</h3>
        <h4>1. Contact Friendly Diamonds Customer Service Department</h4>
        <ul>
            <li>If you feel the need to return an item, please don't hesitate to get in touch with us. Please send us an email at <a rel="nofollow noopener" :href="'mailto:'+$country.email">{{$country.email}}</a> with your order number and the word "Return" in the subject line, state that you'd like to return the item, and provide all the information regarding your request.</li>
            <li>If returning an item from the United States, our team will create a FREE insured shipping label and email it to you. If you are returning an item from outside the United States, the customer can request a shipping label. The customer will bear the actual shipping cost.</li>
        </ul>

        <h4>2. Pack Your Order</h4>
        <ul>
            <li>Ensure that the actual product along with the diamond certificate and the appraisal certificate is securely packed in the original packaging box.</li>
            <li>For security reasons, do not write ‘jewelry’, ‘diamonds’, or other related words anywhere on the package.</li>
            <li>For safety purposes, please double-box your package.</li>
            <li>Affix the label to the outside of the larger box and drop it off at your nearest courier company location.</li>
            <li>Friendly Diamonds cannot be held responsible for shipping errors – we recommend that customers only use a staffed store-front to send returned items. Please do not use drop boxes or non-staffed locations.</li>
            <li>Obtain a shipping receipt to confirm that the item has been shipped - this receipt will act as proof of shipment and insurance.</li>
        </ul>

        <h3>Refund Process</h3>
        <p>Once we receive the return parcel, our quality assessment team will inspect the item and begin the refund process. Please note the customer may receive a follow-up email or inquiry to determine eligibility if the item is not in like-new condition. Refunds typically take up to 5-7 business days to process. Refunded amounts will be issued via the method of payment used in the original purchase. For all credit card refunds, please allow one monthly billing cycle for your credit to appear.</p>

        <h3>Serial Returns (Bracketing)</h3>
        <p>In order to preserve the exceptional craftsmanship and superior quality of our jewelry and to ensure fairness for all customers, we do not encourage serial returns or bracketing. Bracketing is the act of buying multiple product variations with the intent of returning the ones that are unwanted. We do not accept returns for orders suspected of being bracketing purchases.</p>

        <p>We trust in your understanding that the trend of over-ordering through bracketing mirrors the issues of over-consumption and sustainability. Ultimately, this practice has a negative impact on the environment in the long run.</p>

    </div>
</template>

<script setup>
    const { $country } = useNuxtApp()
</script>

<style scoped>
.main_title {
    margin: 4% 0;
}
.main_title h2 {
    font-size: 40px;
    text-align: center;
}
h1{
    font-size: 32px;
    text-transform: capitalize;
}
p {
    margin-bottom: 0;
    color: #606060;
    font-size: 16px;
    font-weight: 500;
}
ul {
    margin-left: 25px;
    padding-left: 0;
}
ul li{
    color: #606060;
    font-size: 16px;
    font-weight: 500; 
}
h3, h2 {
    font-size: 21px;
    font-weight: 500;
    margin: 30px 0 20px;
}
h4{
    margin-bottom: 6px;
    color: #353535;
    font-size: 16px;
    font-weight: 600;
    line-height: 1.5;
}
a{
    color: var(--green);
    text-decoration: underline;
}


@media(max-width: 767px){
    .main_title h2{
        font-size: 32px;
    }
    .main_title {
        margin: 13% 0 10%;
    }
    h1{
        font-size: 20px;
    }
    h3, h2{
        font-size: 18px;
    }

    p{
        font-size: 14px;
    }

    ul li {
        font-size: 14px;
    }
}
</style>